import ClassNames from 'classnames'
import Button from '@material-ui/core/Button'

import l10n from '../../i18n/I18N'
import { config } from '../../Init/Init'
import { paymentModes } from '../cryptoPaymentConstants'
import { CryptoPaymentDepositForm } from '../CryptoPaymentDeposit'
import { CryptoPaymentWithdrawalForm } from '../CryptoPaymentWithdrawal'
import { useCryptoPaymentDataModal } from '../CryptoPaymentModalDataProvider'
import { useCryptoPaymentModal } from '../CryptoPaymentModalProvider'
import { verifyNotFrozen } from '../../../services/utils'
import { usePlayerStore } from '../../../services/store'

import classes from './cryptoPayment.module.scss'

export const CryptoPayment = () => {
  const playerStore = usePlayerStore()
  const playerFreezeInfo = playerStore.use.playerFreezeInfo()

  const {
    loading,
    setLoading,
    cryptoPaymentModalMode,
    setWithdrawalFormError,
    setCryptoPaymentModalMode
  } = useCryptoPaymentDataModal()

  const { setCryptoPaymentModalPackageAmount } = useCryptoPaymentModal()

  const onLoading = loading => setLoading(loading)

  const purchaseLabel = config.enableSweepstakes
    ? l10n.t['cryptopayment.purchase.button']
    : l10n.t['cryptopayment.deposit.button']

  const redeemLabel = config.enableSweepstakes
    ? l10n.t['cryptopayment.redeem.button']
    : l10n.t['cryptopayment.withdraw.button']

  const depositButtonClassName = ClassNames(classes.cryptoPaymentModeButton, {
    [classes.cryptoPaymentModeButton_selected]: cryptoPaymentModalMode === paymentModes.deposit
  })
  const withdrawalButtonClassName = ClassNames(classes.cryptoPaymentModeButton, {
    [classes.cryptoPaymentModeButton_selected]: cryptoPaymentModalMode === paymentModes.withdrawal
  })

  return (
    <>
      <div className={classes.cryptoPaymentHeader}>{l10n.t['cryptopayment.header']}</div>
      <div className={classes.cryptoPaymentModeButtonGroup}>
        <Button
          className={depositButtonClassName}
          disabled={loading || !verifyNotFrozen(playerFreezeInfo, config.freezeEvents.depositFrozen)}
          onClick={() => {
            if (!loading && cryptoPaymentModalMode !== paymentModes.deposit) {
              setCryptoPaymentModalMode(paymentModes.deposit)
              onLoading(true)
              setWithdrawalFormError('')
            }
          }}
        >
          {purchaseLabel}
        </Button>
        <Button
          className={withdrawalButtonClassName}
          disabled={loading || !verifyNotFrozen(playerFreezeInfo, config.freezeEvents.withdrawFrozen)}
          onClick={() => {
            if (!loading && cryptoPaymentModalMode !== paymentModes.withdrawal) {
              setCryptoPaymentModalMode(paymentModes.withdrawal)
              setCryptoPaymentModalPackageAmount(null)
            }
          }}
        >
          {redeemLabel}
        </Button>
      </div>
      {cryptoPaymentModalMode === paymentModes.deposit && <CryptoPaymentDepositForm />}
      {cryptoPaymentModalMode === paymentModes.withdrawal && <CryptoPaymentWithdrawalForm />}
    </>
  )
}
